<template>
  <header class="flex items-center gap-2.5">
    <Avatar
      :size="ComponentSize.lg"
      :entity="
        data
          ? {
              name: data.shipment?.carrier,
              image: getCarrierLogoUrl(data.shipment?.carrier),
            }
          : {}
      "
    />
    <div class="flex flex-col">
      <p class="text-body-large-m">
        {{ `#${data?.id}` || "-" }}
      </p>
      <p class="text-body-default">
        {{ t("created") }}
        {{ formatDate(data?.created_at, { format: DateTime.DATE_MED }) }}
      </p>
    </div>
  </header>
  <Badge v-if="data?.status" v-bind="getBadgeStyle(data.status.state)">{{ t(data.status.name) }}</Badge>
  <div
    class="text-body-default [&>*:nth-child(even)]: [&>*:nth-child(odd)]:odd:text-fgr-primary grid w-full grid-cols-[max-content_1fr] gap-x-2 gap-y-3.5 [&>*:nth-child(odd)]:odd:break-words"
  >
    <p class="self-center">{{ t("type") }}</p>
    <Badge class="truncate" :strong="false">
      {{ data?.type?.name ? t(data.type.name) : "-" }}
    </Badge>
    <p class="self-center">{{ t("created_by") }}</p>
    <div v-if="data?.owner" class="flex items-center gap-2">
      <Avatar
        :size="ComponentSize.md"
        :entity="
          data
            ? {
                name: data.owner,
              }
            : {}
        "
      />
      {{ data?.owner }}
    </div>
    <span v-else>-</span>
    <p class="self-center">{{ t("carrier") }}</p>
    <div class="flex items-center gap-2">
      <Avatar
        :size="ComponentSize.md"
        :entity="
          data
            ? {
                name: data.shipment?.carrier,
                image: getCarrierLogoUrl(data.shipment?.carrier),
              }
            : {}
        "
      />
      {{ data?.shipment?.carrier_name }}
    </div>
    <p>{{ t("package_number") }}</p>
    <p>{{ data?.shipment?.package_number || "-" }}</p>
    <p>{{ t("weight") }}</p>
    <p>{{ useFormatWeight(data?.shipment?.weight || 0) }}</p>
    <p>{{ t("receiver") }}</p>
    <p class="break-words">
      {{ data?.shipment?.receiver.attention }}<br v-show="data?.shipment?.receiver.attention" />
      {{ data?.shipment?.receiver.name }}<br />
      {{ data?.shipment?.receiver.street1 }} <br />
      {{ data?.shipment?.receiver.street2 }} <br />
      {{ data?.shipment?.receiver.zip_code }}
      {{ data?.shipment?.receiver.city }} <br />
      {{ data?.shipment?.receiver.country }}
    </p>
    <p>{{ t("pallet_number") }}</p>
    <p>{{ palletNumber }}</p>
  </div>
</template>

<script lang="ts" setup>
  import { DateTime } from "luxon";
  import type { ITicketSimple } from "~/types/ticket";

  const { formatDate } = useDate();

  defineOptions({
    name: "GlobalSearchInfoTicket",
  });

  const { data } = defineProps<{
    data: ITicketSimple;
  }>();

  const { t } = useI18n();

  const { getBadgeStyle } = useTickets();

  const palletNumber = computed(() => {
    return data.shipment?.meta?.pallet_number?.at(-1) || "-";
  });
</script>
